/* global window */

import LeafletMap from './components/map/map';
import Sidebar from './components/sidebar/sidebar';
import ProjectPicker from './components/project-picker/project-picker';
import PurchaseSidebar from './components/sidebar/purchase-sidebar';
import PicConfirm from './components/pic-confirm/pic-confirm';
import PicConfirmForm from './components/pic-confirm-form/pic-confirm-form';
import Toast from '../toast/toast.vue';
import PicModal from './components/pic-modal/pic-modal.vue';
import MobileRedeemCoupon from './components/mobile-redeem-coupon/mobile-redeem-coupon';
import MobileSidebar from './components/sidebar/mobile-sidebar';

import * as types from '../../store/mutation-types';
import { TIMEOUT } from '../../store/constants';

export default {
  components: {
    'leaflet-map': LeafletMap,
    'sidebar': Sidebar,
    'project-picker': ProjectPicker,
    'purchase-sidebar': PurchaseSidebar,
    'pic-confirm': PicConfirm,
    'pic-confirm-form': PicConfirmForm,
    'toast': Toast,
    'pic-modal': PicModal,
    'mobile-redeem-coupon': MobileRedeemCoupon,
    'mobile-sidebar': MobileSidebar,
  },
  computed: {
    creatingPurchase() {
      return this.$store.state.map.creatingPurchase;
    },
    plotCart() {
      return this.$store.state.map.plotCart;
    },
    plotCartItems() {
      return this.$store.getters.plotCartAsArray;
    },
    plotCartSize() {
      return this.$store.getters.plotCartSize;
    },
    purchase() {
      return this.$store.state.map.purchase;
    },
    sidebarOpened() {
      return this.$store.state.ui.sidebarOpened;
    },
    mobileSidebarOpened() {
      return this.$store.state.ui.mobileSidebarOpened;
    },
    purchaseSidebarOpened() {
      return this.$store.state.ui.purchaseSidebarOpened;
    },
    toastMsg() {
      return this.$store.state.ui.toastMsg;
    },
    activeProject() {
      return this.$store.getters.activeProject;
    },
    focusedProject() {
      return this.$store.getters.focusedProject;
    },
    projects() {
      return this.$store.getters.projectsAsArray;
    },
    isTutorialModalOpen() {
      return false;
    },
    isMobileRedeemCouponOpen() {
      return this.$store.state.ui.mobileRedeemCouponOpened;
    },
    currentMapZoom() {
      return this.$store.state.map.currentZoom;
    },
    initialProjectId() {
      return this.$store.state.map.initialProject;
    },
    foundation() {
      return this.$store.state.map.foundation;
    },
    mobileHeaderTitle() {
      if (this.foundation) {
        return this.foundation.name;
      } else if (this.activeProject) {
        return this.activeProject.name;
      }

      return 'PIC Parks';
    },
  },
  data() {
    return {
      mapReady: false,
      minZoom: 3,
    };
  },
  methods: {
    setMapReady() {
      this.mapReady = true;
    },
    toggleSidebar(val) {
      if (val) {
        this.$store.commit(types.TOGGLE_SIDEBAR, val);
      } else {
        this.$store.commit(types.TOGGLE_SIDEBAR);
      }
    },
    toggleMobileSidebar(val) {
      if (val) {
        this.$store.commit(types.TOGGLE_MOBILE_SIDEBAR, val);
      } else {
        this.$store.commit(types.TOGGLE_MOBILE_SIDEBAR);
      }
    },
    openRedeemMobileCoupon() {
      this.$store.commit(types.TOGGLE_MOBILE_COUPON, { open: true });
      this.$store.commit(types.CLEAR_CART);
    },
    closeTutorialModal() {
      this.$store.dispatch('closeAndSaveTutorialModal');
    },
    setMapZoom() {
      this.$store.commit(types.SET_ACTIVE_PROJECT_ID, null);
      this.$store.commit(types.SET_CURRENT_ZOOM, this.minZoom);
    },
    loadInitialProject() {
      if (this.projects.length && this.mapReady) {
        const initialProject = this.$store.getters.projectFromSlug(this.initialProjectId);
        if (initialProject) {
          this.$store.commit(types.SET_INITIAL_PROJECT, null);
          this.$store.commit(types.SET_ACTIVE_PROJECT_ID, initialProject.id);
          setTimeout(() => this.$store.commit(types.FOCUS_ON_PROJECT, initialProject.id), TIMEOUT);
        }
      }
    },
    focusWhitelistedProject() {
      if (this.projects.length && window.projectSlug && this.mapReady) {
        const whitelabeledProject = this.$store.getters.projectFromSlug(window.projectSlug);
        if (whitelabeledProject) {
          setTimeout(() => this.$store.commit(types.FOCUS_ON_PROJECT, whitelabeledProject.id), TIMEOUT);
        }
      }
    },
  },
  watch: {
    purchase(val) {
      if (val.status === 'paid') {
        this.openRedeemMobileCoupon();
      }
    },
    mapReady() {
      this.loadInitialProject();
      this.focusWhitelistedProject();
    },
    projects() {
      this.loadInitialProject();
      this.focusWhitelistedProject();
    },
  },
  beforeMount() {
    const whitelabeledProject = window.projectSlug;
    const whitelabeledFoundation = window.foundationSlug;

    if (whitelabeledFoundation) {
      this.$store.commit(types.SET_WHITELABELED_FOUNDATION, whitelabeledFoundation);
    } else if (whitelabeledProject) {
      this.$store.commit(types.SET_WHITELABELED_PROJECT, whitelabeledProject);
    }
  },
  mounted() {
    const projectSlug = location.hash.substr(1);
    if (projectSlug) {
      this.$store.commit(types.SET_INITIAL_PROJECT, projectSlug);
    }

    if (window.localStorage) {
      const hasTutorialBeenSeen = window.localStorage.getItem('tutorialModalSeen');
      this.$store.commit(types.TOGGLE_TUTORIAL_MODAL, !hasTutorialBeenSeen);
    }
  },
};
